import React from "react";
import "./HomeContent.css";
import RecentEvents from "../RecentEvents/RecentEvents";

const HomeContent: React.FC = () => {
  return (
    <>
      <div style={{ float: "left", paddingTop: '20px', paddingLeft: '20px', paddingRight: '20px' }} >
        <p className="top_home_text">At MyBajaPhoto.com we promise to show you what Baja off-road racing is all about.
          Our team of professional photographers brings you a unique perspective of Baja Racing.
          You can order beautiful prints in various sizes or download your photo as a file.
          Your efforts deserve to be remembered, we help your Baja stories last a lifetime!</p>
      </div>
      <div id="events">
        <RecentEvents />
        <div style={{ float: 'left', width: '500px', height: '550px', marginLeft: '10px', paddingLeft: '10px', paddingRight: '10px', borderLeft: '#9e9797 solid 1px', textAlign: 'right' }}>
          <div style={{ width: '490px', height: '295px' }} className="imageBorder">
            <iframe width="488" height="293" title="My Baja Photo YouTube channel"
              src="https://www.youtube.com/embed/H8xnCvofWjY?wmode=transparent"></iframe>
          </div>
          <p>&nbsp;</p>
          <h1>The best off-road racing photography since 2006</h1>
          <p className="content_text">
            Looking to update your social media sites with the best photos of your team? Putting together a promotional packet to gather sponsorship?
            MyBajaPhoto.com is the one place to go. Our archive contains over a decade of the best Baja off-road racing photos. We're proud to have been
            official photographers for some of the best teams in off-road racing.
          </p>
          <div style={{ float: 'left' }}>
            <br /><br />
            <a href="http://www.vildosolaracing.com/" target="_blank" rel="noreferrer" style={{ textAlign: 'center' }}>
              <img src="assets/images/logo/logo_vildosola.png" alt="Vildosola Racing" /></a>
          </div>
          <div style={{ float: 'right' }}>
            <a href="http://rpmoffroad.com/" target="_blank" rel="noreferrer" style={{ textAlign: 'center' }}>
              <img src="assets/images/logo/logo_rpm.png" alt="RPM Offroad" /></a>
          </div>
        </div>
        <br style={{ clear: 'both' }} />&nbsp;
      </div>
      <div id="sponsor">
        <p style={{ textAlign: 'left' }}>Off-Road Organizations we cover:</p>
        <table width="100%" cellSpacing={1} cellPadding={0} style={{ border: '0' }}>
          <tbody>
          <tr>
            <td valign="middle">
              <a href="http://www.losancianos.com/" target="_blank" rel="noreferrer" style={{ textAlign: 'center' }}>
              <img src="assets/images/logo/logo_ancianos.png" alt="Promoter" /></a></td>
            <td valign="middle">
              <a href="http://www.codeoffroad.com.mx/" target="_blank" rel="noreferrer" style={{ textAlign: 'center' }}>
              <img src="assets/images/logo/logo_code.png" alt="Promoter" /></a></td>
            <td valign="middle">
              <a href="http://www.recordoffroad.com/" target="_blank" rel="noreferrer" style={{ textAlign: 'center' }}>
              <img src="assets/images/logo/logo_record.png" alt="Promoter" /></a></td>
            <td valign="middle">
              <a href="http://www.score-international.com/"  target="_blank" rel="noreferrer" style={{ textAlign: 'center' }}>
              <img src="assets/images/logo/logo_score.png" alt="Promoter" /></a></td>
          </tr>
          </tbody>
        </table>
      </div>
    </>
  );
}

export default HomeContent